export default {
    ZOOM: "Масштаб",
    FORMAT: "ФОРМАТ",
    SCREEN: "Скрин",
    OBJECT: "Элемент",
    ALL_SCREEN: "Весь граф",
    CURRENT_SCREEN: "Текущий экран",
    NO_SELECTION_HINT: "Выберите узел графа",
    DELETE: "Удалить",
    COPY: "Копировать",
    PASTE: "Вставить"
};
